<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 9.38838C22 9.69567 21.8518 9.99535 21.5873 10.1592L12.4116 15.881C12.1565 16.0397 11.8437 16.0397 11.5885 15.881L2.41167 10.1617C2.01892 9.91662 1.88251 9.37568 2.11064 8.94775C2.33759 8.52236 2.84206 8.37633 3.23599 8.62141L12.0001 14.0842L20.7653 8.61887C21.158 8.37379 21.6625 8.51982 21.8895 8.94521C21.9647 9.08489 22 9.23854 22 9.38838Z"
      :fill="iconColor"
    />
  </svg>
</template>

<script>
export default {
  name: "IconChevronDown",
  data: () => ({
    iconColor: "currentColor",
  }),
};
</script>
